export default __webpack_public_path__ + "static/retirement-planning-3-1c398f87e62ffd6bd2ebaaf45d5161e3.png";